<!-- 学生注册 -->
<template>
    <div>
        <van-nav-bar
                title="学生注册"
                left-text="返回"
                left-arrow
                fixed
                @click-left="onClickLeft"
        />
        <div class="main">
            <Head :logo='logo'></Head>
            <div>
                <van-field
                        readonly
                        name="picker"
                        :value="deptName"
                />
            </div>
            <van-form @submit="save">
                <div class="formmain" v-if="startMark">
                    <van-cell-group  v-for="(field,index) in fieldList" :key="index">
                        <!-- 下拉 -->
                        <div v-if="field.fieldName == 'grade' ">
                            <van-field
                                readonly
                                clickable
                                :required="field.isNullable == '1'"
                                name="picker"
                                :value="saveBody.grade"
                                :label="field.showName"
                                :placeholder="'点击选择'+field.showName"
                                @click="showPickerOne = true"
                                :rules="ruleFunction(field)"
                            />
                             <van-popup v-model="showPickerOne" position="bottom">
                                <van-picker
                                show-toolbar
                                :columns="gradeList"
                                @confirm="onConfirmOne"
                                @cancel='showPickerOne=false'
                                />
                            </van-popup>
                        </div>
                        <!-- 下拉 -->
                        <div v-else-if="field.fieldName == 'clazz'">
                            <van-field
                                readonly
                                :required="field.isNullable == '1'"
                                clickable
                                name="picker"
                                :value="className"
                                :label="field.showName"
                                :placeholder="'点击选择'+field.showName"
                                @click="showPickerTwo = true"
                                :rules="ruleFunction(field)"
                            />
                             <van-popup v-model="showPickerTwo" position="bottom">
                                <van-picker
                                show-toolbar
                                :columns="clazzList"
                                @confirm="onConfirmTwo"
                                @cancel='showPickerTwo=false'
                                />
                            </van-popup>
                        </div>

                        <!-- 字符串 -->
                        <div v-else-if="field.fieldType == '0'">
                            <van-field
                                    :required="field.isNullable == '1'"
                                    v-model="saveBody[field.fieldName]"
                                    :name="field.fieldName"
                                    :label="field.showName"
                                    :placeholder="`请输入` + field.showName"
                                    :rules="ruleFunction(field)"
                            />
                        </div>
                        <!-- 日期 -->
                        <div v-else-if="field.fieldType == '3'">
                            <van-field
                                    readonly
                                    clickable
                                    :required="field.isNullable == '1'"
                                    name="picker"
                                    :value="saveBody[field.fieldName]"
                                    :label="field.showName"
                                    :placeholder="'点击选择'+field.showName"
                                    @click="changeDate(field)"
                                    :rules="ruleFunction(field)"
                            />

                        </div>

                        <!-- 年份 -->
                        <div v-else-if="field.fieldType == '6'">
                            <selectPicker
                                    :required="field.isNullable == '1'"
                                    :label="field.showName"
                                    :name="field.fieldName"
                                    :placeholder="field.showName"
                                    v-model="saveBody[field.fieldName]"
                                    :columns="yearList"
                                    :selectValue="saveBody[field.fieldName]"
                                    :rules="ruleFunction(field)"
                            />
                        </div>

                        <!-- 下拉 -->
                        <div v-else-if="field.fieldType == '2'">
                            <selectPicker
                                    :required="field.isNullable == '1'"
                                    :label="field.showName"
                                    :name="field.fieldName"
                                    :placeholder="`点击选择` + field.showName"
                                    v-model="saveBody[field.fieldName]"
                                    :columns="listCollect[field.fieldName + 'DictList']"
                                    :selectValue="saveBody[field.fieldName]"
                                    :rules="ruleFunction(field)"
                                    @confirm="onConfirmThree"
                                    @click="pickerClick(field)"
                                    :chooseValue="`value`"
                                    :showValue="`label`"
                            />
                        </div>

                        <!-- 日期时间 -->
                        <div v-else-if="field.fieldType == '4'">
                            <van-field
                                    readonly
                                    clickable
                                    :required="field.isNullable == '1'"
                                    name="picker"
                                    :value="saveBody[field.fieldName]"
                                    :label=" field.showName"
                                    :placeholder="'点击选择'+field.showName"
                                    @click="changeDateTime(field)"
                                    :rules="ruleFunction(field)"
                            />
                        </div>

                        <div v-else>
                            <van-field
                                :required="field.isNullable == '1'"
                                v-model="saveBody[field.fieldName]"
                                :name="field.fieldName"
                                :label="field.showName"
                                :placeholder="`请输入` + field.showName"
                                :rules="ruleFunction(field)"
                            />
                        </div>
                    </van-cell-group>
                </div>
                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit" >
                        注册
                    </van-button>
                </div>
            </van-form>
            <PrivacyDialog style="margin-bottom:20px" person='1' @getReadState='getReadState'></PrivacyDialog>

            <van-calendar v-model="dateTimeShow" :min-date="minDate" @confirm="onConfirmDate" color="#1989fa" />
            <van-popup v-model="dateShow" position="bottom">
             <van-datetime-picker 
                v-model="currentDate" 
                type="datetime" 
                title="选择完整时间"
                @confirm="onConfirmDateTime"/>
            </van-popup>         
        </div>

    </div>
</template>

<script>
    import Head from '@/components/head'
    import Foot from '@/components/foot'
    import selectPicker from '@/components/selectPicker'
    import {Toast,Dialog} from "vant";
    import { formatterDate,savePrivacy } from '@/utils/common'
    import {isEmpty} from "../../utils/common";
    import PrivacyDialog from '@/components/dialog/privacyDialog'

    export default {
        name: "register",
        components: {
            Head,
            Foot,
            selectPicker,
            PrivacyDialog
        },
        data:function(){
          return {
              //
             currentDate: new Date(),
              field:{},
              dateShow:false,
              dateTimeShow:false,
              selectShow:false,
              //
              showPickerOne:false,
              showPickerTwo:false,
              saveBody:{
                deptId:'',
                name: "",
                idCard: "",
                phone: "",
                grade: "",
                clazz: "",
                studentId: "",
                schoolYear: new Date().getFullYear() + '',
                sex: "",
                dateOfBirth: "",
                nativePlace: "",
                nationality: "",
                address: "",
                campus: "",
                  kz1:"",
                  kz2:"",
                  kz3:"",
                  kz4:"",
                  kz5:"",
                  kz6:"",
                  kz7:"",
                  kz8:"",
                  kz9:"",
                  kz10:"",
            },
            deptName:'',// 选中单位名称
            fieldList:[],//学生配置字段列表
            gradeList:[],//年级列表
            className:'',
            clazzList:[],//班级列表
            yearList:[],// 入学年度列表
            logo:'',
              startMark:false,
              //是否显示弹出层
              showPickerCollect:{
                    xxShow:false,
              },
              //全部动态数组
              listCollect:{

              },
              minDate:new Date(1900, 1, 1),
               isRead:false,
            details:[]
          }
        },
        created() {
            this.getHeadImg()
            if (this.$route.query.deptId === undefined) {
                Toast.clear();
                Dialog.alert({
                    title: "提示",
                    message: "地址不正确，请刷新后重试"
                }).then(() => {
                    //返回上一页
                    this.$router.go(-1)
                });
            }else {
                this.saveBody.deptId = this.$route.query.deptId
                this.deptName = this.$route.query.deptName
                this.getFieldList()
                this.getGradeData(this.saveBody.deptId)
                this.yearList = this.getYearArray()
            }
        },
        methods:{
                getReadState(isRead,details) {
                    this.isRead = isRead;
                    this.details = details;
                },
                // 存储隐私授权接口
                savePrivacy() {
                    let data = {
                        details:this.details,
                        userId:this.saveBody.name,
                        userName: this.saveBody.idCard?this.saveBody.idCard:this.saveBody.phone?this.saveBody.phone:this.saveBody.name,
                    };
                    savePrivacy(data);
                },
            onConfirmOne(value) {
                this.saveBody.grade = value
                this.showPickerOne = false
                this.getClazz()
            },
            onConfirmTwo(value) {
                this.className = value.text
                this.saveBody.clazz = value.uId
                this.showPickerTwo = false
            },
            onConfirmThree(value){
                this.selectShow = false;
                this.showPickerCollect[this.field.fieldName + "ShowPicker"] = false;
                this.saveBody[this.field.fieldName] = value.value;
            },
            //注册
            save() {
                if (this.isRead == false) {
                    Dialog.alert({
                        title: "提示",
                        message: "请先阅读《用户隐私政策》",
                    }).then(() => {});
                    return;
                };
                for(let i= 0 ;i < this.fieldList.length; i++){
                    let field = this.fieldList[i];
                    let fieldName = field.fieldName;
                    let fieldType = field.fieldType;
                    let showName = field.showName;
                    let isNullable = field.isNullable;
                    let value = this.saveBody[fieldName];
                    if(isNullable == 1 && isEmpty(value)){
                        Toast.clear();
                        Dialog.alert({
                            title: "错误提示",
                            message: showName + "不能为空"
                        }).then((
                        ) => {});
                        return
                    }else if (fieldType == '1' && !isEmpty(value) && !/^[1-9]\d*$/.test(value)) {
                        Toast.clear();
                        Dialog.alert({
                            title: "错误提示",
                            message:field.showName+"请输入正整数"
                        }).then((
                        ) => {});
                        return
                    }else if (fieldType == '5' && !isEmpty(value) && !/^[1-9]\d*\.\d*|0\.\d*[1-9]\d*$/.test(value)) {
                        Toast.clear();
                        Dialog.alert({
                            title: "错误提示",
                            message:field.showName+"请输入正小数"
                        }).then((
                        ) => {});
                        return
                    }else if (fieldName == 'idCard' &&  !/^[\s\S]{0,19}$/.test(value)) {
                        Toast.clear();
                        Dialog.alert({
                            title: "错误提示",
                            message:field.showName+"长度不小于20"
                        }).then((
                        ) => {});
                        return
                    }
                }
                
                this.request({
                    url:'/prepaid/saveStudentBasicData',
                    method:'post',
                    data: this.saveBody
                }).then((res)=>{
                    if (res.data.code == 1000) {
                        Toast.clear();
                        Dialog.alert({
                            title: "提示",
                            message: "注册成功"
                        }).then(() => {
                            this.savePrivacy();
                            this.resetSaveBody()
                            this.$router.go(-1)
                        });

                    }else{
                        Toast.clear();
                        Dialog.alert({
                            title: "提示",
                            message: res.data.message
                        }).then(() => {});
                    }
                })
            },
            // 页面点击返回
            onClickLeft:function(){
                this.$router.go(-1)
            },
            // 规则
            ruleFunction(o){
                let ru = [];
                let normalRule = {
                    required: true,
                    message: "请" + (o.fieldType == '2' ? '选择' :'输入') + o.showName,
                    trigger: "blur"
                };
                let noRule = {
                    required: false
                };
                //手机号码
                let phoneRule = {
                    pattern: /^1\d{10}$/,
                    message: o.showName + "格式不对",
                    trigger: "blur",
                }
                ru.push(o.isNullable == '1' ? normalRule : noRule);
                if(o.fieldName == 'phone'){
                    ru.push(phoneRule);
                }
                return ru;
            },
            // 获取年级数据
            getGradeData(id) {
                this.gradeList = []
                this.clazzList = []
                this.request({
                    url:'/schoolConfig/listOnlyGradeByDeptId',
                    method:'get',
                    params: { deptId: (id == null ? this.saveBody.deptId : id)}
                }).then((res)=>{
                    if (res.data.code == 1000) {
                        this.gradeList = res.data.result;
                    }
                })
            },
            // 生日选择器确认按钮
            birthConfirm(date){
                this.dateShow = false;
                this.dateTimeShow = false;
                this.selectShow = false;
                this.showPickerCollect[this.field.fieldName + "ShowPicker"] = false;
                this.saveBody[this.field.fieldName] = formatterDate(date.toString())
            },
            getHeadImg() {
                let data = {}
                data.vde = this.vde
                this.request({
                    url:'/webPortal/websitConfig',
                    method:'get',
                    params:data
                }).then((res)=>{
                    if (res.data.code == 1000 && res.data.result) {
                        if (res.data.result.logoUrlLogin) {
                            this.logo = res.data.result.logoUrlLogin
                        }else {
                          this.logo = require('@/assets/img/logo.png')
                         }
                        sessionStorage.setItem('title',res.data.result.websitTitle)
                        document.title=res.data.result.websitTitle 
                    }else if (res.data.code != 1000){
                         this.$router.push({ path: "/404" });
                    }

                })
            },
            // 获取学生配置字段
            getFieldList:function () {
                this.request({
                    url:'/education/getEduStudentField',
                    method:'get',
                    params: {deptId:this.saveBody.deptId}
                }).then((res)=>{
                    if (res.data.code == 1000) {
                        this.fieldList = res.data.result
                        this.renderSelect()
                    }else{
                        Toast.clear();
                        Dialog.alert({
                            title: "提示",
                            message: res.data.message
                        }).then(() => {
                            this.$router.go(-1)
                        });
                    }
                })
            },
            // 获取班级列表
            getClazz:function () {
                this.request({
                    url:'/schoolConfig/listClassByDeptIdGrade',
                    method:'get',
                    params: {deptId:this.saveBody.deptId,grade:this.saveBody.grade}
                }).then((res)=>{
                    if (res.data.code == 1000) {
                        this.clazzList = res.data.result
                        this.clazzList.forEach((item)=>{
                            item.text = item.clazz
                        })
                    }else{
                        Toast.clear();
                        Dialog.alert({
                            title: "提示",
                            message: res.data.message
                        }).then(() => {});
                    }
                })
            },
            // 获取年份数组
            getYearArray:function () {
                const date = new Date();
                const currentYear = date.getFullYear()+10;
                const yearArray = [];
                // 入学年度，最多录入当年的
                const lastYear = currentYear;
                for(let i = lastYear;i >= 1900;i--){
                    yearArray.push(i)
                }
                return yearArray
            },
            // 重置表单
            resetSaveBody:function () {
                this.saveBody = {
                    deptId:this.saveBody.deptId,
                    name: "",
                    idCard: "",
                    phone: "",
                    grade: "",
                    clazz: "",
                    studentId: "",
                    schoolYear: new Date().getFullYear() + '',
                    sex: "",
                    dateOfBirth: "",
                    nativePlace: "",
                    nationality: "",
                    address: "",
                    campus: ""
                }
            },
            //渲染全部下拉
            renderSelect: function(){
                let $this = this;
                let reqArr = []
                $this.fieldList.forEach((item,index) => {
                    let showPicker = item.fieldName + "ShowPicker";
                    //下拉选择框
                    if(item.fieldType =='2' && !isEmpty(item.dictionary)){
                        let listName = item.fieldName + "DictList";
                        reqArr.push(new Promise((resolve)=>{
                            this.request({
                                url:'/system/dictionary/listDictData/' + item.dictionary,
                                method:'get',
                            }).then((res)=>{
                                if (res.data.code == 1000){
                                    let dataList = isEmpty(res.data.result) ? []: res.data.result;
                                    dataList.forEach((item)=>{
                                        item.text = item.label
                                    })
                                    $this.listCollect[listName] = dataList;
                                    $this.showPickerCollect[showPicker] = false;
                                }
                               resolve()

                            })
                        }))

                        //移动端日期也需要有弹出层
                    }else if(item.fieldType == '3' || item.fieldType == '4'){
                        $this.showPickerCollect[showPicker] = false;
                    }
                });
                Promise.all(reqArr).then((result) => {
                    //全部特殊处理完成后才进行渲染页面
                    $this.startMark = true
        
                }).catch((error) => {
                })
            },
            pickerClick(field){
                this.dateShow = false;
                this.dateTimeShow = false;
                this.selectShow = true;
                this.showPickerCollect[field.fieldName + 'ShowPicker'] = true;
                this.field = field
            },

            changeDate(field) {
                this.dateTimeShow = true
                this.field = field
            },
            onConfirmDate(date) {
                this.dateTimeShow = false
                this.saveBody[this.field.fieldName] = this.formatDate(date)
            },
            changeDateTime(field) {
                this.dateShow = true
                this.field = field
            },
            onConfirmDateTime() {
                this.dateShow = false
                this.saveBody[this.field.fieldName] = this.getNowFormatDate(this.currentDate)

            },
            formatDate(date) {
                 // return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
                return formatterDate(date);
            }, 
            getNowFormatDate(date) {
                var seperator1 = '-'
                var seperator2 = ':'
                var month = date.getMonth() + 1
                var strDate = date.getDate()
                var hh = date.getHours()
                var mm = date.getMinutes()
                var ss = date.getSeconds()
                if (month >= 1 && month <= 9) {
                    month = '0' + month
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = '0' + strDate
                }
                if (hh >= 0 && hh <= 9) {
                    hh = '0' + hh
                }
                if (mm >= 0 && mm <= 9) {
                    mm = '0' + mm
                }
                if (ss >= 0 && ss <= 9) {
                    ss = '0' + ss
                }
                var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
                        ' ' + hh + seperator2 + mm + seperator2 + ss
                return currentdate
            }
        }
    }
</script>

<style scoped lang='scss'>
.main {
    margin-top: 50px;
    padding: 0 2vw;
    box-sizing: border-box;
    .formmain {
         background:rgba(255,255,255,1);
        box-shadow:4px 4px 5px 0px rgba(51,51,51,0.05);
        border-radius:5px;
        .van-cell-group {
            background: transparent;
        }
        .van-cell {
            background: transparent;
        }
    }
}
    select{
        width: 100%;
        display: inline-block;
        position: relative;
        line-height: 30px;
        border-radius: 4px;
        height: 25px;
        color: #606266;
        border: 1px solid #dcdfe6;
    }
</style>